<form class="gap-lg grid" [formGroup]="form">
  <div>
    <label for="autocomplete-region" hlmLabel labelRequired>Nom de la région</label>
    <hlm-autocomplete
      id="autocomplete-region"
      [(search)]="search"
      [filteredOptions]="filteredRegions()"
      autocompleteSearchClass="border-stroke-neutral-medium"
      formControlName="region"
    />
  </div>

  <div class="gap-lg grid" formArrayName="noms">
    @for (form of noms.controls; track $index; let idx = $index) {
      <div hlmField>
        <label [for]="'nom-' + idx" hlmFieldLabel>Nom du CFA</label>
        <input [id]="'nom-' + idx" [formControlName]="idx" hlmInput type="text" required />
      </div>
    }
  </div>
  @if (!site()) {
    <app-button-add-new (click)="ajouterSite()" label="Ajouter un autre CFA" />
  }
</form>
